import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import CustomHeaderTitle from "../../constants/CustomHeaderTitle";
import HeaderBread from "../../HeaderBread";
import MobilePagemasterInput from "./MobilePagemasterInput";

const AddMobilePageData = ({ category }) => {
  const params = useParams();
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [navigation, setNavigation] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    getOptionLocation();
  }, []);
  useEffect(() => {
    console.log({ category });
    if (category?.id)
      setNavigation([
        {
          title: "Home",
          route: "/",
        },
        {
          title: "Mobile App Shore CMS",
          route: "/",
        },
        {
          title: "All Pages",
          route: "/shore/all-pages/genting-dream/" + category.id,
        },
        {
          title: vesselOptions.find((item) => item.id == category?.vessel_id)
            ?.name,
          route: "/shore/all-pages/" +
        vesselOptions
          .find((item) => item.id == category?.vessel_id)
          ?.name?.replaceAll(" ", "-")
          ?.toLowerCase() +
        "/" + + category.id,
        },
        {
          title: category?.name,
          route: "/shore/all-pages/" +
        vesselOptions
          .find((item) => item.id == category?.vessel_id)
          ?.name?.replaceAll(" ", "-")
          ?.toLowerCase() +
        "/" + + category.id,
        },
      ]);
  }, [vesselOptions, category]);

  return (
    <Layout type={"create_per"} module_data={"Categories"}>
      <CustomHeaderTitle title={"Create Categories"} />
      <HeaderBread
        navigation={navigation}
        title={"Create " + category?.name + " Page"}
      ></HeaderBread>
      {category&&<MobilePagemasterInput category={category} crisisdata={{}} />}
    </Layout>
  );
};

export default AddMobilePageData;
